<template>
  <div class="txt has-txt-scroll" v-if="data.length" ref="warpRef">
    <div class="in" ref="inRef">
      <vue-seamless-scroll
        :data="data"
        :class-option="classOption"
        class="scroll-box"
      >
        <i v-for="item in data" :key="item">{{ item }}</i>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
  import vueSeamlessScroll from 'vue-seamless-scroll/src'
  export default {
    components: {
      vueSeamlessScroll,
    },
    props: {
      data: {
        type: Array,
        default() {
          return []
        },
      },
      waitTime: {
        type: Number,
        default: 1000,
      },
    },
    data() {
      return {
        boxHeight: 30,
      }
    },
    mounted() {
      this.boxHeight = this.$refs.warpRef ? this.$refs.warpRef.clientHeight : 30
      window.addEventListener('resize', () => {
        this.boxHeight = this.$refs.warpRef
          ? this.$refs.warpRef.clientHeight
          : 30
      })
    },
    unmounted() {},
    computed: {
      classOption() {
        return {
          singleHeight: this.boxHeight,
          waitTime: this.waitTime,
          limitMoveNum: 2,
          direction: 1,
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  .has-txt-scroll {
    position: relative;
    height: 100%;
    overflow: hidden;
    :deep(.in) {
      display: block;
      height: 100%;
      overflow: hidden;
    }
    :deep(i) {
      display: block;
      height: 100%;
    }
  }
</style>
